import { computed, reactive, toRefs } from 'vue'
import { clone } from '@/common/js/just.js'
import { MessageBox } from 'element-ui'
import moment from 'moment'
import { ptomDetailAuthList, complexReportAuthList, promotionAuthList, ACCOUNT_STATUS } from '../consts/data.js'
import { getProxyAccountList, addProxyAccount, updateProxyAccount, changeProxyAccountStatus } from '@/api/ptomAgentInfo.model'

const AUTH_FLAG_ENUM = {
  PTOM_DETAIL: 1, // 投放明细
  COMPLEX_REPORT: 2, // 综合效果报表
  PROMOTION_DATA: 3 // 推广数据
}
const getAuthItmes = () => {
  const ptomDetailAuthListItems = ptomDetailAuthList.map(i => i.items).flat()
  const complexReportAuthListItems = complexReportAuthList.map(i => i.items).flat()
  const promotionAuthListItems = promotionAuthList.map(i => i.items).flat()

  return {
    ptomDetailAuthListItems,
    complexReportAuthListItems,
    promotionAuthListItems
  }
}

const formatMenuJSON = (mune) => {
  try {
    const json = mune ? JSON.parse(mune) : {}
    return json
  } catch (e) {
    console.log('formatMenuJSON error output: ', e)
  }

  return null
}
export const useTable = (queryForm) => {
  const tableModel = reactive({
    tableData: [],
    pager: {
      pageIndex: 1,
      pageSize: 50
    },
    total: 0,
    tableLoading: false,
    tableRef: null
  })

  function getTableData() {
    const { ptomDetailAuthListItems, complexReportAuthListItems, promotionAuthListItems } = getAuthItmes()

    getProxyAccountList({ ...tableModel.pager, ...queryForm.value }).then(data => {
      const { list = [], page_info } = data || {}
      tableModel.tableData = list.map(row => {
        const menuSetting = formatMenuJSON(row.menuSetting)
        const { details } = menuSetting || {}
        const { M20334, M20997, M21265 } = details || {}
        let privilegeText = ''
        if (M20334) {
          const ptomPrivilegeText = ptomDetailAuthListItems.filter(i => M20334.split(',').includes(i.key)).map(i => i.name).join('、')
          privilegeText += `明细数据权限：${ptomPrivilegeText}`
        }
        if (M20997) {
          const complexReportPrivilegeText = complexReportAuthListItems.filter(i => M20997.split(',').includes(i.key)).map(i => i.name).join('、')
          privilegeText += `；综合数据报表：${complexReportPrivilegeText}`
        }
        if (M21265) {
          const promotionPrivilegeText = promotionAuthListItems.filter(i => M21265.split(',').includes(i.key)).map(i => i.name).join('、')
          privilegeText += `；推广数据：${promotionPrivilegeText}`
        }
        return {
          ...row,
          privilegeText,
          addTime: moment(row.addTime).format('YYYY-MM-DD HH:mm:ss'),
          statusText: ACCOUNT_STATUS.find(s => s.value === row.status)?.label || '-'
        }
      })
      tableModel.total = page_info?.total_number || 0
    })
  }

  function onQueryAction(pageIndex = 1) {
    tableModel.pager.pageIndex = pageIndex
    getTableData()
  }

  function onSizeChange(size) {
    tableModel.pager.pageSize = size
    onQueryAction()
  }

  function onUpdateAction(row) {
    console.log('row output: ', row)
  }
  function onRowStatusToggleAction(row) {
    MessageBox.confirm(`确认切换为${row.status === 1 ? '禁用' : '启用'}？`, '确认', { type: 'warning' }).then(() => {
      changeProxyAccountStatus({ id: row.id, status: row.status === 1 ? 0 : 1 })
        .then(data => {
          console.log('data output: ', data)
          getTableData()
        })
    })
  }

  return {
    ...toRefs(tableModel),
    onQueryAction,
    onSizeChange,
    getTableData,
    onUpdateAction,
    onRowStatusToggleAction
  }
}

export const useAddForm = (getTableData) => {
  const getForm = () => {
    return {
      name: '',
      password: '',
      pageAuth: ['M20984', 'M20334', 'M20997', 'M21265'],
      privilege: [],
      remark: '',
      userType: 1,
      deductSwitch: false,
      ratio: ''
    }
  }

  const formModel = reactive({
    addFormVisible: false,
    authItemsModalVisible: false,
    addFormSubmitLoading: false,
    addForm: { ...getForm() },
    authListFlag: AUTH_FLAG_ENUM.PTOM_DETAIL,
    ptomDetailAuthList: [],
    complexReportAuthList: [],
    promotionAuthList: [],
    ptomDetailAuthCheckList: [],
    complexReportAuthCheckList: [],
    promotionAuthCheckList: [],
    addFormRef: null
  })

  const addFormRules = {
    name: [
      { required: true, message: '请输入名称', trigger: 'blur' },
      { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
    ],
    password: [
      { required: true, message: '请输入密码', trigger: 'blur' },
      { min: 6, max: 24, message: '长度在 6 到 24 个字符', trigger: 'blur' }
    ],

    ratio: [
      { required: true, message: '请输入扣量比例', trigger: 'change' },
      {
        validator(rule, value, callback) {
          const val = String(value ?? '').trim()
          // 允许空值通过，由业务决定是否必填
          if (val === '') return callback()
          // 只允许 0-100 的正整数
          const ok = /^(100|[1-9]?\d)$/.test(val)
          if (!ok) return callback(new Error('请输入 0-100 的正整数'))
          callback()
        },
        trigger: 'blur'
      }
    ]
  }

  const authList = computed(() => {
    if (formModel.authListFlag === AUTH_FLAG_ENUM.PTOM_DETAIL) return formModel.ptomDetailAuthList
    if (formModel.authListFlag === AUTH_FLAG_ENUM.COMPLEX_REPORT) return formModel.complexReportAuthList
    return formModel.promotionAuthList
  })
  const authListTitle = computed(() => {
    if (formModel.authListFlag === AUTH_FLAG_ENUM.PTOM_DETAIL) return '明细数据权限'
    if (formModel.authListFlag === AUTH_FLAG_ENUM.COMPLEX_REPORT) return '综合数据报表'
    return '推广数据'
  })

  const authCheckListText = computed(() => {
    return {
      ptomDetails: formModel.ptomDetailAuthCheckList.map(i => i.name).join('、'),
      complextReport: formModel.complexReportAuthCheckList.map(i => i.name).join('、'),
      promotion: formModel.promotionAuthCheckList.map(i => i.name).join('、')
    }
  })

  function showAddFormModal() {
    formModel.addFormVisible = true
  }

  function showPtomDetailAuthModal() {
    if (!formModel.ptomDetailAuthCheckList.length) {
      // 如果是编辑，且全部勾选项为空，那么就没有默认勾选值
      if (formModel.addForm.id) {
        formModel.ptomDetailAuthList = ptomDetailAuthList.map(i => ({ ...i, items: i.items.map(j => ({ ...j, checked: false })) }))
      } else {
        // 如果是新增，有5个默认勾选项
        formModel.ptomDetailAuthList = clone(ptomDetailAuthList)
      }
    } else {
      const checkedKeys = formModel.ptomDetailAuthCheckList.map(i => i.key)
      formModel.ptomDetailAuthList = ptomDetailAuthList.map(i => ({
        ...i,
        items: i.items.map(j => ({
          ...j,
          checked: checkedKeys.includes(j.key)
        }))
      }))
    }
    formModel.authItemsModalVisible = true
    formModel.authListFlag = AUTH_FLAG_ENUM.PTOM_DETAIL
  }

  function showComplexReportAuthModal() {
    if (!formModel.complexReportAuthCheckList.length) {
      // 如果是编辑，且全部勾选项为空，那么就没有默认勾选值
      if (formModel.addForm.id) {
        formModel.complexReportAuthList = complexReportAuthList.map(i => ({ ...i, items: i.items.map(j => ({ ...j, checked: false })) }))
      } else {
        // 如果是新增，有5个默认勾选项
        formModel.complexReportAuthList = clone(complexReportAuthList)
      }
    } else {
      const checkedKeys = formModel.complexReportAuthCheckList.map(i => i.key)
      formModel.complexReportAuthList = complexReportAuthList.map(i => ({
        ...i,
        items: i.items.map(j => ({
          ...j,
          checked: checkedKeys.includes(j.key)
        }))
      }))
    }
    formModel.authItemsModalVisible = true
    formModel.authListFlag = AUTH_FLAG_ENUM.COMPLEX_REPORT
  }

  function showPromotionAuthModal() {
    if (!formModel.promotionAuthCheckList.length) {
      // 如果是编辑，且全部勾选项为空，那么就没有默认勾选值
      if (formModel.addForm.id) {
        formModel.promotionAuthList = promotionAuthList.map(i => ({ ...i, items: i.items.map(j => ({ ...j, checked: false })) }))
      } else {
        // 如果是新增，有5个默认勾选项
        formModel.promotionAuthList = clone(promotionAuthList)
      }
    } else {
      const checkedKeys = formModel.promotionAuthCheckList.map(i => i.key)
      formModel.promotionAuthList = promotionAuthList.map(i => ({
        ...i,
        items: i.items.map(j => ({
          ...j,
          checked: checkedKeys.includes(j.key)
        }))
      }))
    }
    formModel.authItemsModalVisible = true
    formModel.authListFlag = AUTH_FLAG_ENUM.PROMOTION_DATA
  }

  function authListModalCancel() {
    formModel.authItemsModalVisible = false
  }
  function authListModalConfirm() {
    const checkedItems = authList.value.flatMap(i => i.items.filter(j => j.checked))

    if (formModel.authListFlag === AUTH_FLAG_ENUM.PTOM_DETAIL) {
      formModel.ptomDetailAuthCheckList = checkedItems
    } else if (formModel.authListFlag === AUTH_FLAG_ENUM.COMPLEX_REPORT) {
      formModel.complexReportAuthCheckList = checkedItems
    } else {
      formModel.promotionAuthCheckList = checkedItems
    }

    authListModalCancel()
  }

  function checkAllAuthItems(flag) {
    const flatMapItemCheckedState = (list) => {
      return list.map(i => {
        return {
          ...i,
          items: i.items.map(j => {
            if (j.disabled) return { ...j, checked: true }
            return { ...j, checked: flag }
          })
        }
      })
    }

    if (formModel.authListFlag === AUTH_FLAG_ENUM.PTOM_DETAIL) {
      formModel.ptomDetailAuthList = flatMapItemCheckedState(formModel.ptomDetailAuthList)
    } else if (formModel.authListFlag === AUTH_FLAG_ENUM.COMPLEX_REPORT) {
      formModel.complexReportAuthList = flatMapItemCheckedState(formModel.complexReportAuthList)
    } else {
      formModel.promotionAuthList = flatMapItemCheckedState(formModel.promotionAuthList)
    }
  }

  async function onAccountAddConfirm() {
    const { pageAuth, privilege, deductSwitch, ratio, id, ...addFormFields } = formModel.addForm
    try {
      await formModel.addFormRef.validate()
      formModel.addFormSubmitLoading = true

      const params = {
        ...addFormFields,
        ratio: deductSwitch ? ratio : 0,
        menuSetting: {
          privilege_menu: pageAuth,
          details: {
            M20997: formModel.complexReportAuthCheckList.map(i => i.key).join(','),
            M20334: formModel.ptomDetailAuthCheckList.map(i => i.key).join(','),
            M21265: formModel.promotionAuthCheckList.map(i => i.key).join(',')
          }
        }
      }
      await (id ? updateProxyAccount({ ...params, id }) : addProxyAccount(params))
      formModel.addFormSubmitLoading = false
      onAccountAddCancel()
      getTableData()
    } catch (e) {
      console.log('onAccountAddConfirm error output: ', e)
      formModel.addFormSubmitLoading = false
    }
  }

  function onAccountAddCancel() {
    formModel.addFormVisible = false
    formModel.addForm = getForm()
    formModel.ptomDetailAuthCheckList = []
    formModel.complexReportAuthCheckList = []
    formModel.promotionAuthCheckList = []
  }

  function onUpdateAction(row) {
    const menuSetting = formatMenuJSON(row.menuSetting)
    const { details, privilege_menu } = menuSetting || {}

    formModel.addForm = {
      id: row.id,
      name: row.name,
      password: row.password,
      pageAuth: privilege_menu || [],
      remark: row.remark,
      ratio: row.ratio,
      deductSwitch: row.ratio && row.ratio > 0

    }
    const { ptomDetailAuthListItems, complexReportAuthListItems, promotionAuthListItems } = getAuthItmes()
    const ptomAuthKeys = details?.M20334?.split(',') || []
    const complexAuthKeys = details?.M20997?.split(',') || []
    const promotionAuthKeys = details?.M21265?.split(',') || []
    formModel.ptomDetailAuthCheckList = ptomDetailAuthListItems.filter(i => ptomAuthKeys.includes(i.key))
    formModel.complexReportAuthCheckList = complexReportAuthListItems.filter(i => complexAuthKeys.includes(i.key))
    formModel.promotionAuthCheckList = promotionAuthListItems.filter(i => promotionAuthKeys.includes(i.key))
    showAddFormModal()
  }

  return {
    ...toRefs(formModel),
    authListTitle,
    authList,
    addFormRules,
    showAddFormModal,
    showPtomDetailAuthModal,
    showComplexReportAuthModal,
    showPromotionAuthModal,
    authCheckListText,
    authListModalConfirm,
    authListModalCancel,
    checkAllAuthItems,
    onAccountAddConfirm,
    onAccountAddCancel,
    onUpdateAction
  }
}
